import { post,get, postJson,postBlob,imagePost,deleteApiJson } from '../axios'

export const getServiceList = p => get(`/sysMoneyAlipay/priceConfigs`, p);

export const getList = p => get(`/sysMoneyAlipay/moneyAlipay/page`, p);